import { render } from "./YebPwdSetting.vue?vue&type=template&id=bb99dbd6&scoped=true"
import script from "./YebPwdSetting.vue?vue&type=script&lang=js"
export * from "./YebPwdSetting.vue?vue&type=script&lang=js"

import "./YebPwdSetting.vue?vue&type=style&index=0&id=bb99dbd6&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb99dbd6"]])

export default __exports__